export enum ConditionOperator {
  AND = "and",
  OR = "or",
}
